/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PaymentEventProperties } from "./PaymentEventProperties";

/**
 * A destination that sends the user to a hosted Stripe Checkout Session.
 */
export interface StripeCheckoutSessionRedirect {
  type?: "stripe_checkout_session_redirect";
  /** The hosted Stripe Checkout Session URL to redirect to. */
  value: string;
  /** The Stripe Checkout Session id */
  session_id: string;
  /** Canonical properties emitted when this Checkout Session was created. */
  checkout_started_properties?: PaymentEventProperties | null;
}
